module.exports = __webpack_public_path__ + "media/NeueHaasUnicaW1G-Heavy.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/NeueHaasUnicaW1G/NeueHaasUnicaW1G-Heavy.woff
// module id = 1580
// module chunks = 57